module.exports = __webpack_public_path__ + "static/recursiveStart-d29d43c8a97e5a344db777554377f220.png";